import {
  withCompInfo,
  withCompPreviewInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData,
  StripColumnsContainerCss,
} from '../StripColumnsContainer.types';

export const props = withCompInfo<
  StripColumnsContainerCarmiData,
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData
>()([], (_, carmiData) => {
  return carmiData;
});

export const css = withCompPreviewInfo<
  StripColumnsContainerCss,
  StripColumnsContainerDefinition,
  StripColumnsContainerCss
>()([], (_, carmiData) => {
  return carmiData;
});

export default createComponentMapperModel({
  props,
  css,
});
